import { render, staticRenderFns } from "./UncacheImage.vue?vue&type=template&id=20d246d4"
import script from "./UncacheImage.vue?vue&type=script&lang=js"
export * from "./UncacheImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports